import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";
import BgImg from "../../../images/case-studies/novelcraft/tek_img_04.webp";

function Highlights() {
  return (
    <section
      className="high_sec_novel p-100"
      style={{ backgroundImage: `url(${BgImg})` }}
    >
      <Container className="h-100">
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={10}
            xl={10}
            xxl={10}
            className="mx-auto text-center"
          >
            <div className="img_boxing">
              <StaticImage
                src="../../../images/case-studies/novelcraft/tek_img_05.webp"
                alt="novelcraft TekRevol"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={642}
                height={1087}
              />
            </div>

            <h2>Abby</h2>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Highlights;
